import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import './tutorial-card.scss';
import RightArrowMin from '@assets/icons/right-arrow-min.svg';
const TutorialCard = ({ label, action }) => {
    return (_jsxs(Box, { className: "tutorial-card", onClick: action, children: [_jsx("span", { children: label }), _jsx("img", { src: RightArrowMin, alt: 'right-arrow-min' })] }));
};
export default TutorialCard;
